import React, { useState, useEffect, useRef } from 'react';
import './HiredJobCard.css'
import menu from '../../../assets/images/three-line-menu.svg';
import menuClose from '../../../assets/images/three-line-close.svg';
import CompanyLogo from '../../../assets/images/company-logo.png';
import { useNavigate } from "react-router-dom";
import Rating from '../../../components/Rating';
import Startrating from '../../../components/StarRating/startRating'



const HiredJobCard = ({ data, id }) =>
{

    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [icon, setIcon] = useState(menu);
    const navigate = useNavigate();

    // Ref to detect outside clicks
    const menuRef = useRef();

    const toggleMenu = (e) =>
    {
        if (isMenuOpen)
        {
            setIsMenuOpen(false);
        } else
        {
            setIsMenuOpen(true);
        }
    };

    const openEditJob = () =>
    {
        console.log("Navigate to job detail with ID:", id);
        navigate("/job-detail", { state: { jobId: id, duplicate: 0 } });
    }


    const duplicateJob = () =>
    {
        console.log("Navigate to job detail with ID:", 0);
        navigate("/job-detail", { state: { jobId: id, duplicate: 1 } });
    }

    // Detect clicks outside the menu to close it
    useEffect(() =>
    {
        const handleClickOutside = (event) =>
        {
            if (menuRef.current && !menuRef.current.contains(event.target))
            {
                setIsMenuOpen(false); // Close the menu
            }
        };

        // Add event listener for clicks outside
        document.addEventListener('mousedown', handleClickOutside);

        return () =>
        {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <div className='job-card'>
            <div className='card_title position-relative gap-1'>

                <div className='d-flex align-items-center'>
                    <img src={CompanyLogo} className="comapny-logo" ref={menuRef} alt='Menu' />
                    <div>
                        <h3>{data.name}</h3>
                        <p className='card_title-l'>{data.location} </p>
                    </div>
                </div>

                <img src={isMenuOpen ? menuClose : menu} className="menu-container" ref={menuRef} alt='Menu' onClick={toggleMenu} />
                {/* Conditionally render the menu based on state */}
                {isMenuOpen && (
                    <ul className="menu-list" style={{ right: '-130px' }} ref={menuRef}>
                        <li >Open Profile</li>
                        <li >Invite To Job</li>
                        <li>Message</li>
                    </ul>
                )}
            </div>


            <div className='card_item mb-0'>
                <p className='job-card-description'>{data.description}</p>
                <p className='job-card-description d-flex gap-1'>
                    Rating :
                    <span className='review'> <Startrating ratings={data.overallrating} /></span>
                </p>

                <div className='job-status-quote mb-0'>
                    <p>Status: &nbsp;
                        <span className='quote-color open-status'>
                            {data.jobStatus}
                        </span>
                    </p>
                    <p>Quotes: {data.quotes}</p>
                    {/* <span className="mb-4">Job Completed : {data.jobStatus}</span>
                    <span className='ms-5'>Quotes: {data.quotes}</span> */}
                </div>


            </div>

        </div>
    )
}

export default HiredJobCard
